"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _twilioActionKeys = _interopRequireDefault(require("../constants/twilioActionKeys"));
var _twilioServices = require("../services/twilioServices");
var _angieslistAppPlatform = require("angieslist-app-platform");
var _redux = require("redux");
var _twilioUrlUtils = require("../../modules/common/utils/twilioUrlUtils");
var getClientReducer = _angieslistAppPlatform.AsyncRequest.createReducer(_twilioActionKeys["default"].GET_CLIENT, (0, _defineProperty2["default"])({}, _twilioActionKeys["default"].GET_CLIENT_SUCCESS, function (state, action) {
  var twilioClient = action.payload.client;
  var _action$payload = action.payload,
    spId = _action$payload.spId,
    userId = _action$payload.userId;
  action.addSideEffect(function (store) {
    twilioClient.on('messageAdded', /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(message) {
        var getMessagesResponse, twilioMessages, twilioConversationName, newMessage;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              getMessagesResponse = (0, _get2["default"])(store.getState(), 'twilio.getMessages.response');
              twilioMessages = getMessagesResponse.messages;
              twilioConversationName = getMessagesResponse.conversationName;
              _context.next = 5;
              return (0, _twilioUrlUtils.modifyTwilioMessages)(message);
            case 5:
              newMessage = _context.sent;
              store.dispatch({
                type: _twilioActionKeys["default"].GET_MESSAGES_SUCCESS,
                payload: {
                  messages: [].concat((0, _toConsumableArray2["default"])(twilioMessages), [newMessage]),
                  conversationName: twilioConversationName
                }
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });
  twilioClient.on('tokenAboutToExpire', /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    var res, clientToken;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _twilioServices.getThread)(spId, userId);
        case 2:
          res = _context2.sent;
          clientToken = res.body.clientToken;
          _context2.next = 6;
          return twilioClient.updateToken(clientToken);
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })));
  twilioClient.on('tokenExpired', /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var res, clientToken;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _twilioServices.getThread)(spId, userId);
        case 2:
          res = _context3.sent;
          clientToken = res.body.clientToken;
          _context3.next = 6;
          return twilioClient.updateToken(clientToken);
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })));
  return state;
}));
var getMessagesReducer = _angieslistAppPlatform.AsyncRequest.createReducer(_twilioActionKeys["default"].GET_MESSAGES, (0, _defineProperty2["default"])({}, _twilioActionKeys["default"].GET_MESSAGES_SUCCESS, function (state, action) {
  return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
}));
var sendMessageReducer = _angieslistAppPlatform.AsyncRequest.createReducer(_twilioActionKeys["default"].SEND_MESSAGE, (0, _defineProperty2["default"])({}, _twilioActionKeys["default"].SEND_MESSAGE_SUCCESS, function (state, action) {
  return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
}));
var getPreviousMessagesReducer = _angieslistAppPlatform.AsyncRequest.createReducer(_twilioActionKeys["default"].GET_PREVIOUS_MESSAGES, (0, _defineProperty2["default"])({}, _twilioActionKeys["default"].GET_PREVIOUS_MESSAGES_SUCCESS, function (state, action) {
  action.addSideEffect(function (store) {
    var getMessagesResponse = (0, _get2["default"])(store.getState(), 'twilio.getMessages.response');
    var twilioMessages = getMessagesResponse.messages;
    var twilioConversationName = getMessagesResponse.conversationName;
    var olderMessages = action.payload.messages;
    store.dispatch({
      type: _twilioActionKeys["default"].GET_MESSAGES_SUCCESS,
      payload: {
        messages: [].concat((0, _toConsumableArray2["default"])(olderMessages), (0, _toConsumableArray2["default"])(twilioMessages)),
        conversationName: twilioConversationName
      }
    });
  });
  return state;
}));
var setAllMessagesReadReducer = _angieslistAppPlatform.AsyncRequest.createReducer(_twilioActionKeys["default"], (0, _defineProperty2["default"])({}, _twilioActionKeys["default"].SET_ALL_MESSAGES_READ_SUCCESS, function (state, action) {
  return _angieslistAppPlatform.AsyncRequest.setSuccess(state, action.payload);
}));
var _default = exports["default"] = (0, _redux.combineReducers)({
  getClient: getClientReducer,
  getMessages: getMessagesReducer,
  sendMessage: sendMessageReducer,
  getPreviousMessages: getPreviousMessagesReducer,
  setAllMessagesRead: setAllMessagesReadReducer
});
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/lead-ion/lib/common/reducers/twilioReducer.js
// module id = 2735
// module chunks = 25